import axios from '@/libs/api.request'
import config from '@/config'

// Dashboard 基础URL
const baseDashboardUrl = config.baseDashboardUrl
const dashboardUrl = baseDashboardUrl + '/api/dashboard/'

// 查询数据中心列表
export const getIdcList = (params) => {
  return axios.request({
    url: dashboardUrl + 'idc/list',
    params: params,
    method: 'get'
  })
}

// 查询机柜列表
export const getCabinetList = (id) => {
  return axios.request({
    url: dashboardUrl + 'idc/' + id,
    method: 'get'
  })
}

// 创建IDC
export const saveIdc = (data) => {
  return axios.request({
    url: dashboardUrl + 'idc/create',
    data: data,
    method: 'post'
  })
}

// 创建机柜
export const saveJg = (data) => {
  return axios.request({
    url: dashboardUrl + 'cabinet/create',
    data: data,
    method: 'post'
  })
}

// 删除机柜
export const deleteJg = (id) => {
  return axios.request({
    url: dashboardUrl + 'cabinet/' + id,
    method: 'delete'
  })
}

// 创建机柜上的主机
export const saveJgHost = (data) => {
  return axios.request({
    url: dashboardUrl + 'host_cabinet/create',
    data: data,
    method: 'post'
  })
}

// 修改机柜上的主机
export const editJgHost = (data) => {
  return axios.request({
    url: dashboardUrl + 'host_cabinet/' + data.id + '/update',
    data: data,
    method: 'put'
  })
}

// 删除机柜上的主机
export const deleteJgHost = (id) => {
  return axios.request({
    url: dashboardUrl + 'host_cabinet/' + id + '/delete',
    method: 'delete'
  })
}

// 获取持续交付待办列表
export const getDeployUpcomingList = (id) => {
  return axios.request({
    url: dashboardUrl + 'deploy/list',
    method: 'get'
  })
}

// 获取液晶面板文字
export const getHostLedTxt = (params) => {
  return axios.request({
    url: dashboardUrl + 'host_led_txt',
    params: params,
    method: 'get'
  })
}
